import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { Flex } from '@components/Flex';

export const StyledSection = styled(Box)``;

export const StyledAppBody = styled(Box)`
  width: 100%;
  margin-top: -5px;
  position: relative;
  min-height: 530px;
  ${themeMediaQuery('below_sm')} {
    height: 1000px;
  }
  @media (min-width: 414px) and (max-width: 414px) {
    height: 950px;
  }
`;

export const LeftSectionTextPairing = styled(TextPairing)`
  .text-pairing-eyebrow {
    margin-top: ${themeSpace(10)};
  }
  .text-pairing-title {
    max-width: 280px;
  }
  .text-pairing-body {
    max-width: 300px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 420px;
    }
    .text-pairing-body {
      max-width: 400px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    text-align: center;
    .text-pairing-body {
      max-width: 250px;
    }
  }
`;

export const RightSectionWrapper = styled(Box)`
  position: relative;
  width: 100%;
  min-height: 530px;
  ${themeMediaQuery('below_sm')} {
    margin-top: 200px;
  }
  @media (max-width: 375px) {
    margin-top: 0px;
  }
  @media (max-width: 320px) {
    margin-top: 0px;
  }
  @media (min-width: 400px) and (max-width: 420px) {
    margin-left: -80px;
  }
`;

export const TheAppShapeImage = styled(CloudImage)`
  position: absolute;
  top: 100px;
  left: 0;
  ${themeMediaQuery('below_sm')} {
    left: 30px;
    top: 0px;
  }
  @media (max-width: 375px) {
    left: -46px;
    width: 385px;
    top: 220px;
  }
  @media (max-width: 320px) {
    left: -62px;
    width: 357px;
    top: 220px;
  }
`;

export const TheMobileImage = styled(CloudImage)`
  height: 570px;
  position: absolute;
  bottom: -20px;
  left: 70px;
  min-width: 250px;
  ${themeMediaQuery('below_sm')} {
    bottom: 60px;
    left: 84px;
  }
  @media (max-width: 375px) {
    left: -12px;
    bottom: -90px;
  }
  @media (max-width: 320px) {
    left: -37px;
    bottom: -90px;
  }
`;

export const TheGoldThreadImage = styled(CloudImage)`
  position: absolute;
  top: 80px;
  left: -150px;
  ${themeMediaQuery('below_sm')} {
    left: -68px;
    width: 528px;
    top: 60px;
  }
  @media (max-width: 375px) {
    left: -120px;
    width: 507px;
    top: 201px;
  }
  @media (max-width: 320px) {
    left: -120px;
    width: 465px;
    top: 201px;
  }
  @media (min-width: 400px) and (max-width: 420px) {
    left: -45px;
    top: 0px;
  }
`;

export const IOSAndroidStyledFlex = styled(Flex)`
  justify-content: left;
  img {
    width: 170px;
    ${themeMediaQuery('below_sm')} {
      width: 160px;
    }
    @media (max-width: 320px) {
      width: 120px;
    }
    &:first-of-type {
      margin-bottom: 45px;
      margin-right: ${themeSpace(6)};
      ${themeMediaQuery('below_sm')} {
        margin-bottom: 0;
        margin-right: 11px;
      }
    }
  }
  ${themeMediaQuery('below_sm')} {
    justify-content: center;
  }
`;
